import { jsx as _jsx, Fragment as _Fragment } from "nativewind/jsx-runtime";
import React from 'react';
import MenuBookmarkIcon from '@/assets/icon/menu_ic_bookmark.svg';
import MenuCrusherIcon from '@/assets/icon/menu_ic_crusher.svg';
import MenuFlagIcon from '@/assets/icon/menu_ic_flag.svg';
import MenuReviewIcon from '@/assets/icon/menu_ic_review.svg';
import MenuSCCRoadIcon from '@/assets/icon/menu_ic_scc_road.svg';
import MenuSettingIcon from '@/assets/icon/menu_ic_setting.svg';
import MenuRow from '@/components/MenuRow';
import useNavigation from '@/navigation/useNavigation';
export default function MenuListSection() {
    const navigation = useNavigation();
    function goToConquerer() {
        navigation.navigate('Conquerer');
    }
    function goToSavedPlaces() {
        navigation.navigate('MySaves');
    }
    function goToCrusherHistory() {
        navigation.navigate('CrusherActivity', { qr: undefined });
    }
    function goToSCCRoad() {
        navigation.navigate('Webview', {
            fixedTitle: '뿌클로드: 이동약자를 위한 진짜 리뷰',
            url: 'https://www.staircrusher.club/crusher_road',
        });
    }
    function goToReview() {
        navigation.navigate('Review');
    }
    function goToSettings() {
        navigation.navigate('Setting');
    }
    const menuItems = [
        {
            elementName: 'menu_favorite_places',
            title: '내 저장',
            icon: _jsx(MenuBookmarkIcon, {}),
            onPress: goToSavedPlaces,
        },
        {
            elementName: 'menu_conquerer_report',
            title: '정복한 장소',
            icon: _jsx(MenuFlagIcon, {}),
            onPress: goToConquerer,
        },
        {
            elementName: 'menu_review_report',
            title: '내 리뷰',
            icon: _jsx(MenuReviewIcon, {}),
            onPress: goToReview,
        },
        {
            elementName: 'menu_crusher_activity',
            title: '크러셔 활동',
            icon: _jsx(MenuCrusherIcon, {}),
            onPress: goToCrusherHistory,
        },
        {
            elementName: 'menu_challenge',
            title: '참여 챌린지 보기',
            hidden: true,
            disabled: true,
            badgeText: '준비중',
        },
        {
            elementName: 'menu_badge',
            title: '달성 뱃지 보기',
            hidden: true,
            disabled: true,
            badgeText: '준비중',
        },
        {
            elementName: 'menu_bbucleroad',
            title: '뿌클로드: 이동약자를 위한 진짜 리뷰',
            icon: _jsx(MenuSCCRoadIcon, {}),
            onPress: goToSCCRoad,
        },
        {
            elementName: 'menu_social_login',
            title: '간편 로그인 설정',
            hidden: true,
            disabled: true,
            badgeText: '준비중',
        },
        {
            elementName: 'menu_settings',
            title: '설정',
            icon: _jsx(MenuSettingIcon, {}),
            onPress: goToSettings,
        },
        {
            elementName: 'menu_challenge',
            title: '참여 챌린지 보기',
            hidden: true,
            disabled: true,
            badgeText: '준비중',
        },
        {
            elementName: 'menu_badge',
            title: '달성 뱃지 보기',
            hidden: true,
            disabled: true,
            badgeText: '준비중',
        },
    ];
    return (_jsx(_Fragment, { children: menuItems.map(item => (_jsx(MenuRow, Object.assign({}, item), `${item.elementName}-${item.title}`))) }));
}
